import React, { Component } from "react";
import './Menu.css';
import logo from '../../assets/images/logo.svg';
import inOrange from '../../assets/images/inOrange.png';
import ytOrange from '../../assets/images/ytOrange.png';
import fbOrange from '../../assets/images/fbOrange.png';
import twitOrange from '../../assets/images/twitOrange.png';
import siteOrange from '../../assets/images/siteOrange.png';
import { MDBRow, MDBCol } from "mdbreact";

class Menu extends Component {

    render() {
        return (
            <div>
                <MDBRow className="menu">
                    <MDBCol size="12" sm="2" md="2" lg="2" xl="2" className="wow bounceInDown animated">
                        <img src={logo} className="logo" height="82" />
                    </MDBCol>
                    <MDBCol size="12" sm="6" md="6" lg="6" xl="2" className="offset-sm-4 offset-md-4 offset-lg-4 offset-xl-8">
                        <MDBRow className="iconos">
                            <MDBCol size="1" sm="2" lg="2" className="colMenuHide">
                            </MDBCol>
                            <MDBCol size="2" sm="2" md="2" lg="2" xl="2">
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.instagram.com/nuevo_ingresoufg"
                                    className="letterLink"
                                >
                                    <img src={inOrange} className="icono" />
                                </a>
                            </MDBCol>
                            <MDBCol size="2" sm="2" md="2" lg="2" xl="2">
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.youtube.com/user/redsocialufg"
                                    className="letterLink"
                                >
                                    <img src={ytOrange} className="icono" />
                                </a>
                            </MDBCol>
                            <MDBCol size="2" sm="2" md="2" lg="2" xl="2">
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://es-la.facebook.com/ufgoficial"
                                    className="letterLink"
                                >
                                    <img src={fbOrange} className="icono" />
                                </a>
                            </MDBCol>
                            <MDBCol size="2" sm="2" md="2" lg="2" xl="2">
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://twitter.com/UFGoficial"
                                    className="letterLink"
                                >
                                    <img src={twitOrange} className="icono" />
                                </a>
                            </MDBCol>
                            <MDBCol size="2" sm="2" md="2" lg="2" xl="2">
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.ufg.edu.sv/"
                                    className="letterLink"
                                >
                                    <img src={siteOrange} className="icono" />
                                </a>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>
            </div >
        );
    }
}
export default Menu;